/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { string, object } from 'prop-types';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';
import findContent from '../../../../gql/queries/findContent';
import FrequentlyAskedQuestionsUI from './FrequentlyAskedQuestionsUI';
import { getBrand } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const FrequentlyAskedQuestions = ({ queryTitle, brand }) => {
    const Question_Answers = findContent({
        brand: brand.domain,
        contentType: 'question_answer_list',
        query: `\\"title\\" : \\"${queryTitle}\\"`,
    });
    const celebrationsFaqQuery = findContent({
        brand: 'celebrations',
        contentType: 'celebrations_faq_customer_service',
    });
    const { data, error, loading } = useQuery(Question_Answers);
    const {  data: celebrationsFaqData, error: celebrationsFaqError, loading: celebrationsFaqLoading } = useQuery(celebrationsFaqQuery);
    if (loading || celebrationsFaqLoading) {
        return <div style={{ height: '170px' }} />;
    }

    if (error || celebrationsFaqError) {
        return null;
    }

    const questionAnswers = data?.findContent?.content?.entries || [];
    const celebrationsFaq = celebrationsFaqData?.findContent?.content?.entries || [];
    const faqData = questionAnswers?.[0]
        ? {
            ...questionAnswers[0],
            categories: [
                ...(questionAnswers?.[0]?.categories || []),
                ...(celebrationsFaq?.[0]?.categories || []),
            ],
        }
        : null;

    if (faqData) {
        return <FrequentlyAskedQuestionsUI faqData={faqData} />;
    }
    return null;
};

FrequentlyAskedQuestions.propTypes = {
    queryTitle: string.isRequired,
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});
export default connect(mapStateToProps)(FrequentlyAskedQuestions);
